/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HookAction
 */
export interface HookAction {
    /**
     * 
     * @type {string}
     * @memberof HookAction
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HookAction
     */
    type: HookActionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof HookAction
     */
    name?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof HookAction
     */
    config: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof HookAction
     */
    enabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HookAction
     */
    created_at?: number;
    /**
     * 
     * @type {number}
     * @memberof HookAction
     */
    updated_at?: number;
}


/**
 * @export
 */
export const HookActionTypeEnum = {
    Email: 'email',
    Sms: 'sms',
    Push: 'push',
    Teams: 'teams'
} as const;
export type HookActionTypeEnum = typeof HookActionTypeEnum[keyof typeof HookActionTypeEnum];


/**
 * Check if a given object implements the HookAction interface.
 */
export function instanceOfHookAction(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "config" in value;

    return isInstance;
}

export function HookActionFromJSON(json: any): HookAction {
    return HookActionFromJSONTyped(json, false);
}

export function HookActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): HookAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'type': json['type'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'config': json['config'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
        'updated_at': !exists(json, 'updated_at') ? undefined : json['updated_at'],
    };
}

export function HookActionToJSON(value?: HookAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': value.type,
        'name': value.name,
        'config': value.config,
        'enabled': value.enabled,
        'created_at': value.created_at,
        'updated_at': value.updated_at,
    };
}

